package pl.mothdigital.neuronowi.components.sections.contactheader

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.theme.*

@Composable
fun ContactHeaderSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 4.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50)
            .toAttrs()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
                .textAlign(TextAlign.Center),
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            AppH1(color = SiteTheme.green._900) {
                Text("Skontaktuj się z nami".fixPolishOrphans())
            }

            AppP(color = SiteTheme.green._800) {
                Text("Masz pytania lub chcesz umówić wizytę? Sprawdź, jak możesz się z nami skontaktować.".fixPolishOrphans())
            }
        }
    }
}
